export const OPEN_LOG_VIEWER_PANEL_ACTION = 'LOG_VIEWER.OPEN_LOG_VIEWER_PANEL_ACTION';
export const REJECT_LOG_VIEWER_TRANSACTION = 'LOG_VIEWER.REJECT_LOG_VIEWER_TRANSACTION';
export const RESOLVE_LOG_VIEWER_TRANSACTION = 'LOG_VIEWER.RESOLVE_LOG_VIEWER_TRANSACTION';
export const GET_ALL_LOGS_ACTION = 'LOG_VIEWER.GET_ALL_LOGS_ACTION';
export const OPEN_LOG_DETAIL_MODAL_TRANSACTION = 'LOG_VIEWER.OPEN_LOG_DETAIL_MODAL_TRANSACTION';
export const SET_LOG_NAMES = 'LOG_VIEWER.SET_LOG_NAMES';
export const SET_LOG_TOTAL_COUNT = 'LOG_VIEWER.SET_LOG_TOTAL_COUNT';
